import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/webforms'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      company: null,
      name: null,
      email: null,
      phone: null,
      message: null,
      kvkk: null,
      iys: null,
      ip_address: null,
      attachment: null,
      id_webform_departments: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        company: null,
        name: null,
        email: null,
        phone: null,
        message: null,
        kvkk: null,
        iys: null,
        ip_address: null,
        attachment: null,
        id_webform_departments: null,
        id_users: null,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      commit('RESET_DATA_ITEM')
      const data = JSON.stringify({
        where: {
          'webforms.id': id,
        },
        array: false,
      })
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
        })
        .catch(error => console.error(error))
    },
  },
}
